import { NetworkUrlOfChainId, EthRPCEndpoints, ChainType, ThetaRPCEndpoints } from 'common/constants';

const host = 'https://testnet-explorer.thetatoken.org';
const hostApi = 'https://testnet-explorer-api.thetatoken.org';
const hostWs = 'https://testnet-explorer-ws.thetatoken.org';
const config = {
    restApi: {
        host: hostApi,
        port: 443
    },
    socketApi: {
        host: hostWs,
        port: 443
    },
    defaultThetaChainID: NetworkUrlOfChainId[host],
    ethRPCEndpoint: EthRPCEndpoints[host],
    thetaRPCEndPoint: ThetaRPCEndpoints[host],
    chainInfo: {
        metachain: {
            host: "https://testnet-metachain-explorer.thetatoken.org"
        },
        mainchain: {
            name: 'Theta Testnet Main Chain',
            description: 'The Main Chain serves as the Metachain Hub and coordinates the Subchains.',
            host: 'https://testnet-explorer.thetatoken.org',
            logoName: "theta",
            restApiPort: 8443,
            socketApiPort: 2096
        },
       subchains: [{
            name: 'Subchain Demo',
            description: 'Subchain Demo, a sandbox environment for developers and users to experience the Theta Metachain technology.',
            host: 'https://testnet-tsub360777-explorer.thetatoken.org',
            hostApi: 'https://testnet-tsub360777-explorer-api.thetatoken.org',
            hostWs: 'https://testnet-tsub360777-explorer-ws.thetatoken.org',
            logoName: "theta",
            restApiPort: 443,
            socketApiPort: 443
        },{
            name: 'Replay Subchain Test',
            description: 'Replay Subchain demo, a subchain dedicated to the Replay, a video tracking and payments platform powered by Theta.',
            host: 'https://testnet-tsub88888-explorer.thetatoken.org',
            hostApi: 'https://testnet-tsub88888-explorer-api.thetatoken.org',
            hostWs: 'https://testnet-tsub88888-explorer-ws.thetatoken.org',
            logoName: "replay",
            restApiPort: 443,
            socketApiPort: 443
        }]
    },
    chainName: 'Theta Testnet Main Chain',
    chainType: ChainType.MAINCHAIN,
    tokenMap: {
        TDrop: '0x08a0c0e8EFd07A98db11d79165063B6Bc2469ADF', //address for testnet
        TFuelTransfer: ['0x859938d8b3ff02b29cb491b8e0996eb1c86d89f1','0x216871f4c3b11369750f4b215aeadf0129bdbf58'],
    },
    disableSSL: true
};
export default config;